import Vue from 'vue'
import loader from '@/loader'
import axios from 'axios'
import envConfig from "/public/static/json/env-config.json";
import intlTelInput from 'intl-tel-input'
global.intlTelInput = intlTelInput
require('intl-tel-input/build/css/intlTelInput.min.css')


let token = window.location.hash.split('/')[1]
if (!token) {
    // для локалки
    // window.location = '/#/store'

    // для гита
    window.location = '/web'
}

axios.interceptors.request.use(config => {
    config.headers.subdomain = window.location.host.split('.')[0]
    config.headers.token = token || null
    return config
})

let baseUrl = process.env.VUE_APP_API_BASEURL
let axiosConfig = async() => {
    let urlParams = new URLSearchParams(window.location.search);
    let obj = {
        method: 'GET',
        url: `${baseUrl}v2/webview/config`,
        headers: {
            identity: await loader.getIdentity(),
            merge: 1
        }
    }
    if (urlParams.get('t')) {
        obj.headers['queryParams'] = btoa(JSON.stringify({
            t: urlParams.get('t')
        }))
    }
    return obj
};

axiosConfig().then(conf => {
    axios(conf).then(async response => {
        if (response.data.mode === 1) {
            loader.setMode(loader.const.ECOMMERCE)
        } else {
            loader.setMode(loader.const.DEFAULT)
        }
        await loader.setResponseConfig(response.data)
        if (response.data.favicon) {
            const favicon = document.createElement('link')
            favicon.setAttribute('rel', 'shortcut icon')
            favicon.setAttribute('type', 'image/x-icon')
            favicon.setAttribute('href', `${response.data.favicon}`)
            document.querySelector('head').append(favicon)
        } else {
            document.querySelector('head').insertAdjacentHTML('beforeend', `
        <link rel="apple-touch-icon" sizes="57x57" href="../favicon/apple-icon-57x57.png">
        <link rel="apple-touch-icon" sizes="60x60" href="/favicon/apple-icon-60x60.png">
        <link rel="apple-touch-icon" sizes="72x72" href="/favicon/apple-icon-72x72.png">
        <link rel="apple-touch-icon" sizes="76x76" href="/favicon/apple-icon-76x76.png">
        <link rel="apple-touch-icon" sizes="114x114" href="/favicon/apple-icon-114x114.png">
        <link rel="apple-touch-icon" sizes="120x120" href="/favicon/apple-icon-120x120.png">
        <link rel="apple-touch-icon" sizes="144x144" href="/favicon/apple-icon-144x144.png">
        <link rel="apple-touch-icon" sizes="152x152" href="/favicon/apple-icon-152x152.png">
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-icon-180x180.png">
        <link rel="icon" type="image/png" sizes="192x192" href="/favicon/android-icon-192x192.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="96x96" href="/favicon/favicon-96x96.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png">
        <link rel="manifest" href="/favicon/manifest.json">
      `)
        }
    }).catch(() => {
        loader.setMode(loader.const.DEFAULT)
    }).finally(() => {
        if (loader.responseConfig.notWorking) {
            startNotWorking()
        } else {
            startApp()
        }
    })
})

async function startApp() {
    const store = await loader.initStore()
    const router = await loader.initRouter()

    Vue.config.productionTip = true

    Vue.filter('capitalize', function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    })
    Vue.filter('replace', function(value, from, to) {
        return value.toString().replace(from, to)
    })
    Vue.filter('nl2br', function(str, isXhtml) {
        if (typeof str === 'undefined' || str === null) {
            return ''
        }

        let breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>'

        return (str + '')
            .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1')
    })

    Vue.filter('toCurrency', function(value) {
        if (typeof value !== 'number') {
            return value
        }
        let currencyData
        if (loader.WEBVIEW_MODE === loader.const.DEFAULT) {
            currencyData = store.getters.outlet.data.currency
        } else {
            currencyData = store.getters.outlet.currency
        }
        let formatter = new Intl.NumberFormat(currencyData.locale, {
            style: 'currency',
            currency: currencyData.currency,
            minimumFractionDigits: currencyData.num_decimals,
        })

        return formatter.format(value)
    })

    Vue.directive('scroll', {
        inserted: function(el, binding) {
            let f = function(evt) {
                if (binding.value(evt, el)) {
                    window.removeEventListener('scroll', f)
                }
            }
            window.addEventListener('scroll', f)
        }
    })

    Vue.prototype.text = ((key, placeholders = {}, options = {}) => {
        let text = store.getters.text(key, placeholders)
        if (text) {
            if (options.removeTags) {
                let doc = new DOMParser().parseFromString(text, 'text/html')
                text = doc.body.textContent || ''
            }
            text = text.replace(/\n/g, '<br>')
        }
        return text
    })

    Vue.prototype.loader = (() => {
        return loader
    })

    import ('@/' + loader.view('App')).then(component => {
        new Vue({
            router: router,
            store: store,
            render: h => h(component.default),
            created() {},
            async mounted() {
                await loader.style()
                await loader.fillStore()
                this.$nextTick(() => {
                    (function(d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0]
                        if (d.getElementById(id)) {
                            return
                        }
                        js = d.createElement(s)
                        js.id = id
                        js.src = '//connect.facebook.net/en_US/messenger.Extensions.js'
                        fjs.parentNode.insertBefore(js, fjs)
                    }(document, 'script', 'Messenger'))
                    let htmlEl = document.querySelector("html")
                    htmlEl.setAttribute('dir', loader.css_direction)
                })
            }
        }).$mount('#app')
    })
}

function startNotWorking() {
    let overlay = document.getElementById('overlay')
    window.scrollTo(0, overlay.scrollTop)
    overlay.style.display = 'none'

    document.querySelector('#app').insertAdjacentHTML('beforeend', `
        <div class="container_main data-container" style="background: #fff;padding-top: 25px;min-height: calc(100% - 25px);min-width: 320px;max-width: 420px;margin: 0 auto;margin-bottom: -26px;">
          <div style="text-align: center">
            <span style="font-size: 28px;padding: 40px 20px;display: block;font-weight: 600;">${loader.responseConfig.notWorkingText}</span>
            <img style="height: 200px; width: 200px" src="${loader.responseConfig.notWorkingImage}" />
          </div>
        </div>
      `)
}
